/*
 * Converts an array into an hashmap based on key
 * keys is "id" by default
 * */

export const getHashMap = (state = [], key = 'id') => {
  let map = {};
  for (let i = 0; i < state.length; i++) {
    map[state[i][key]] = state[i];
  }
  return map;
};
